import { render, staticRenderFns } from "./GjwListPage.vue?vue&type=template&id=15a7a8ed&scoped=true&"
import script from "./GjwListPage.vue?vue&type=script&lang=js&"
export * from "./GjwListPage.vue?vue&type=script&lang=js&"
import style0 from "./GjwListPage.vue?vue&type=style&index=0&id=15a7a8ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7a8ed",
  null
  
)

export default component.exports